import { Box, Typography, useTheme } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import React, { JSX } from "react"
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UnstyledLink from "../../components/common/UnstyledLink/UnstyledLink";

interface Props{
    left: JSX.Element, 
    right: JSX.Element,
    bgcolor?: string,
    borderColor?: string
    to?: string
}

const AssetInfoChip = ({ left, right, bgcolor, borderColor, to}: Props) => {
    const theme = useTheme();
    return (<Box flexGrow={1} display={"flex"} flexDirection={"row"} gap={2}>
        <Box
            flexGrow={1}
            display={"flex"} flexDirection={"row"}
            justifyContent={"space-between"}
            sx={{
                padding: 3,
                bgcolor: bgcolor,
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 3,
                borderColor: borderColor
            }}>
                {left}
                {right}
        </Box>
    </Box>)
}

export default AssetInfoChip